export const TRACKABLE_EVENTS = {
  answerSearch: {
    searchTermModified: 'answerSearch:searchTermModified',
  },
  actionCentre: {
    connectionRequestActionsMenuClicked: 'actionCentre:connectionRequestActionsMenuClicked',
    connectionRequestMenuActionClicked: 'actionCentre:connectionRequestMenuActionClicked',
    connectionRequestResendSubmitted: 'actionCentre:connectionRequestResendSubmitted',
    viewed: 'actionCentre:viewed',
  },
  aiAssessmentReview: {
    bannerViewed: 'aiAssessmentReview:bannerViewed',
    generated: 'aiAssessmentReview:generated',
    hovered: 'aiAssessmentReview:hovered',
    tabOpened: 'aiAssessmentReview:tabOpened',
    actionClicked: 'aiAssessmentReview:actionClicked',
    actionTaken: 'aiAssessmentReview:actionTaken',
    dismissed: 'aiAssessmentReview:dismissed',
    undismissed: 'aiAssessmentReview:undismissed',
  },
  appearance: {
    themeChanged: 'appearance:themeChanged',
  },
  assessment: {
    completed: 'assessment:completed',
    confirmed: 'assessment:confirmed',
    copiedLink: 'assessment:copiedLink',
    exportedCSV: 'assessment:exported csv',
    exportedPDF: 'assessment:exported pdf',
    search: 'assessment:search',
  },
  assessmentCommunitySignals: {
    headerButtonClicked: 'assessmentCommunitySignals:headerButtonClicked',
    drawerTabOpened: 'assessmentCommunitySignals:drawerTabOpened',
  },
  assessmentOverview: {
    startedReassessment: 'assessmentOverview:started reassessment',
  },
  assessmentWizard: {
    search: 'assessmentWizard:search',
  },
  auth: {
    login: 'auth:login',
  },
  becomeSupplier: {
    requestDemo: 'becomeSupplier:requestDemo',
  },
  clientReporting: {
    exportedActivityCSV: 'client reporting:exported activity csv',
    exportedComplianceCSV: 'client reporting:exported compliance csv',
    exportedPerformanceCSV: 'client reporting:exported performance csv',
  },
  clientAssessment: {
    editAnswer: 'clientAssessment:editAnswer',
  },
  clientDocuments: {
    bulkDownloaded: 'clientDocuments:bulkDownloaded',
  },
  clientDashboard: {
    clickAverageCompliance: 'clientDashboard:clickAverageCompliance',
    clickAverageComplianceBreakdown: 'clientDashboard:clickAverageComplianceBreakdown',
    clickIncompleteAssessments: 'clientDashboard:clickIncompleteAssessments',
    clickOpenRisks: 'clientDashboard:clickOpenRisks',
    clickOpenRisksBreakdown: 'clientDashboard:clickOpenRisksBreakdown',
    clickPendingInvitesRequests: 'clientDashboard:clickPendingInvitesRequests',
    clickPendingInvitesRequestsBreakdown: 'clientDashboard:clickPendingInvitesRequestsBreakdown',
    clickPendingRemediations: 'clientDashboard:clickPendingRemediations',
    clickPendingRemediationsBreakdown: 'clientDashboard:clickPendingRemediationsBreakdown',
    clickSuppliersAwaitingReview: 'clientDashboard:clickSuppliersAwaitingReview',
    clickSuppliersAwaitingReviewBreakdown: 'clientDashboard:clickSuppliersAwaitingReviewBreakdown',
    clickTotalSuppliers: 'clientDashboard:clickTotalSuppliers',
    clickTotalSuppliersBreakdown: 'clientDashboard:clickTotalSuppliersBreakdown',
    goToEmergingThreat: 'clientDashboard:goToEmergingThreat',
    navigateToApprovalsExpired: 'clientDashboard:navigateToApprovalsExpired',
    navigateToApprovalsExpiringSoon: 'clientDashboard:navigateToApprovalsExpiringSoon',
    navigateToDiscussions: 'clientDashboard:navigateToDiscussions',
    navigateToPendingReceivedConnectionRequests:
      'clientDashboard:navigateToPendingReceivedConnectionRequests',
    navigateToRecentlyExpiredInvites: 'clientDashboard:navigateToRecentlyExpiredInvites',
    navigateToRemediationResponses: 'clientDashboard:navigateToRemediationResponses',
    navigateToSuppliersNoPoliciesApplied: 'clientDashboard:navigateToSuppliersNoPoliciesApplied',
  },
  clientInsights: {
    controlsSelected: 'clientInsights:controlsSelected',
    errorPage: 'clientInsights:errorPage',
    exportCSV: 'clientInsights:exportCSV',
    noResults: 'clientInsights:noResults',
    suppliersSelected: 'clientInsights:suppliersSelected',
  },
  clientMonitoring: {
    clickedAssetOverviewDiscussion: 'clientMonitoring:clickedAssetOverviewDiscussion',
    exportCSV: 'clientMonitoring:exportCSV',
    monitoringInterested: 'clientMonitoring:monitoringInterested',
  },
  clientNetwork: {
    filtersApplied: 'clientNetwork:filtersApplied',
  },
  clientNetworkTable: {
    exportCSV: 'clientNetworkTable:exportCSV',
  },
  clientSupplierAssessmentView: {
    filterApplied: 'clientSupplierAssessmentView:filterApplied',
  },
  community: {
    requestAccess: 'community:request-access',
  },
  connectionRequest: {
    missingContactDetails: 'connectionRequest:missingContactDetails',
  },
  connectionViewSubEntities: {
    exportCSV: 'connectionViewSubEntities:exportCSV',
  },
  connectionViewSuppliers: {
    delete: 'connectionViewSuppliers:delete',
    deleteModalClose: 'connectionViewSuppliers:deleteModalClose',
    deleteModalOpen: 'connectionViewSuppliers:deleteModalOpen',
    editNameModalOpen: 'connectionViewSuppliers:editNameModalOpen',
    editNameModalOpenClose: 'connectionViewSuppliers:editNameModalOpenClose',
    exportCSV: 'connectionViewSuppliers:exportCSV',
    save: 'connectionViewSuppliers:save',
    saveModalClose: 'connectionViewSuppliers:saveModalClose',
    saveModalOpen: 'connectionViewSuppliers:saveModalOpen',
  },
  createRole: {
    blankRoleSelected: 'createRole:blankRoleSelected',
    existingRoleSelected: 'createRole:existingRoleSelected',
  },
  discussion: {
    replied: 'discussion:replied',
    started: 'discussion:started',
  },
  documents: {
    attached: 'documents:attached',
    detached: 'documents:detached',
    failedUpload: 'documents:failedUpload',
    'failedUpload:removed': 'documents:failedUpload:removed',
    'failedUpload:retried': 'documents:failedUpload:retried',
    'selectionModal:deselected': 'documents:selectionModal:deselected',
    'selectionModal:opened': 'documents:selectionModal:opened',
    'selectionModal:search': 'documents:selectionModal:search',
    'selectionModal:selected': 'documents:selectionModal:selected',
  },
  emergingThreatsClients: {
    buttonCTA: 'emergingThreatsClients:buttonCTA',
    criticalityFilter: 'emergingThreatsClients:criticalityFilter',
    exportCSV: 'emergingThreatsClients:exportCSV',
    readMoreCTA: 'emergingThreatsClients:readMoreCTA',
    sortChanged: 'emergingThreatsClients:sortChanged',
    'supplierList:exportCSV': 'emergingThreatsClients:supplierList:exportCSV',
  },
  emergingThreatsSuppliers: {
    buttonCTA: 'emergingThreatsSuppliers:buttonCTA',
    readMoreCTA: 'emergingThreatsSuppliers:readMoreCTA',
    sortChanged: 'emergingThreatsSuppliers:sortChanged',
    submitAnswer: 'emergingThreatsSuppliers:submitAnswer',
    submitScoping: 'emergingThreatsSuppliers:submitScoping',
    updateAssignedUser: 'emergingThreatsSuppliers:updateAssignedUser',
    updateStatus: 'emergingThreatsSuppliers:updateStatus',
  },
  externalLink: {
    clicked: 'externalLink:clicked',
  },
  externalMonitoring: {
    requestCapacity: 'externalMonitoring:RequestCapacity',
  },
  federatedNetworkTable: {
    exportCSV: 'federatedNetworkTable:exportCSV',
  },
  federatedSubEntitiesSuppliers: {
    exportCSV: 'federatedSubEntitiesSuppliers:exportCSV',
  },
  file: {
    downloaded: 'fileDownloaded',
    previewClosed: 'filePreviewClosed',
    previewOpened: 'filePreviewOpened',
    reviewPrinted: 'filePreviewPrinted',
    previewSwitched: 'filePreviewSwitched',
    previewZoomed: 'filePreviewZoomed',
    publicDownloaded: 'publicFileDownloaded',
  },
  gettingStarted: {
    addedColleague: 'gettingStarted:addedColleague',
    autoSuggestedClicked: 'gettingStarted:autoSuggestedClicked',
    complete: 'gettingStarted:complete',
    scopingClicked: 'gettingStarted:scopingClicked',
  },
  modeSwitcherModal: {
    close: 'modeSwitcherModal:close',
    open: 'modeSwitcherModal:open',
  },
  navBar: {
    addUsers: 'navBar:addUsers',
  },
  networkVisualisation: {
    enteredFullscreen: 'networkVisualisation:enteredFullscreen',
  },
  org: {
    becameClient: 'org:became client',
    becameSupplier: 'org:became supplier',
  },
  orgSurvey: {
    submit: 'orgSurvey:submit',
  },
  policies: {
    columnsMatrix: 'policies:columnsMatrix',
    exportMatrix: 'policies:exportMatrix',
    exportCSV: 'policies:exportCSV',
  },
  postAssessment: {
    modalOpened: 'postAssessment:modalOpened',
    stepUpdate: 'postAssessment:stepUpdate',
  },
  profileAssessment: {
    search: 'profileAssessment:search',
  },
  profileEvidence: {
    downloadFiles: 'profileEvidence:downloadFiles',
  },
  profileSharing: {
    closeSidePanel: 'profileSharing:closeSidePanel',
    closeUpdateSidePanel: 'profileSharing:closeUpdateSidePanel',
    openSidePanel: 'profileSharing:openSidePanel',
  },
  profileSummary: {
    generated: 'profileSummary:generated',
    autoGenerated: 'profileSummary:autoGenerated',
    generateButtonViewed: 'profileSummary:generateButtonViewed',
    exportedPDF: 'profileSummary:exportedPDF',
    feedbackPositive: 'profileSummary:feedbackPositive',
    feedbackNegative: 'profileSummary:feedbackNegative',
    regenerated: 'profileSummary:regenerated',
    copied: 'profileSummary:copied',
    expanded: 'profileSummary:expanded',
  },
  profileSharingPublic: {
    'openEvidenceModal:assessmentTab': 'profileSharingPublic:openEvidenceModal:assessmentTab',
    'openEvidenceModal:evidenceTab': 'profileSharingPublic:openEvidenceModal:evidenceTab',
    signupEvidenceModal: 'profileSharingPublic:signupEvidenceModal',
  },
  quickConnect: {
    searchOutcomeOrgFound: 'quickConnect:searchOutcomeOrgFound',
    searchOutcomeNewOrgCreated: 'quickConnect:searchOutcomeNewOrgCreated',
    searchOutcomeExited: 'quickConnect:searchOutcomeExited',
  },
  reassessment: {
    confirmDomain: 'reassessment:confirmDomain',
  },
  reporting: {
    pdfExport: 'reporting:pdfExport',
  },
  request: {
    failed: 'requestFailed',
  },
  reviewRecap: {
    downloaded: 'reviewRecap:downloaded',
  },
  reviewSharing: {
    peerReviewViewed: 'reviewSharing:peerReviewViewed',
    peerReviewListViewed: 'reviewSharing:peerReviewListViewed',
  },
  risk: {
    closed: 'risk:closed',
    deleted: 'risk:deleted',
    exportCSV: 'risk:exportCSV',
    opened: 'risk:opened',
    reopened: 'risk:reopened',
    updated: 'risk:updated',
  },
  risks: {
    viewReporting: 'risks:viewReporting',
  },
  scoping: {
    completed: 'scoping:completed',
  },
  session: {
    changedInOtherTab: 'session:changedInOtherTab',
  },
  settings: {
    userAdded: 'settings:userAdded',
  },
  startReviewAssignments: {
    shown: 'startReviewAssignments:shown',
    cleared: 'startReviewAssignments:cleared',
    reset: 'startReviewAssignments:reset',
    kept: 'startReviewAssignments:kept',
    cancelled: 'startReviewAssignments:cancelled',
  },
  startReviewPrompt: {
    shown: 'startReviewPrompt:shown',
    accepted: 'startReviewPrompt:accepted',
    declined: 'startReviewPrompt:declined',
  },
  supplierContact: {
    opened: 'supplierContact:opened',
    submitted: 'supplierContact:submitted',
  },
  supplierConversion: {
    becameClient: 'supplierConversion:becameClient',
    trialInitiated: 'supplierConversion:trialInitiated',
  },
  supplierCoverage: {
    stepViewed: 'supplierCoverage:stepViewed',
    drawerOpened: 'supplierCoverage:drawerOpened',
    uploadAttempted: 'supplierCoverage:uploadAttempted',
    uploadSucceeded: 'supplierCoverage:uploadSucceeded',
    uploadFailed: 'supplierCoverage:uploadFailed',
    submitted: 'supplierCoverage:submitted',
    closedWithoutSubmit: 'supplierCoverage:closedWithoutSubmit',
  },
  supplierMonitoring: {
    closedAddAssetModal: 'supplierMonitoring:closedAddAssetModal',
    closedEditAssetModal: 'supplierMonitoring:closedEditAssetModal',
    exportCSV: 'supplierMonitoring:exportCSV',
    openedAddAssetModal: 'supplierMonitoring:openedAddAssetModal',
    openedEditAssetModal: 'supplierMonitoring:openedEditAssetModal',
  },
  // Trial "explore network visualisation" Getting Started task funnel (SCAG-768).
  // NOTE: literal event-name strings still need sign-off from the data team
  // (codebase `namespace:action` vs the behaviour doc's snake_case).
  trialNetworkViz: {
    taskExpanded: 'trialNetworkViz:taskExpanded',
    videoPlayed: 'trialNetworkViz:videoPlayed',
    beginClicked: 'trialNetworkViz:beginClicked',
    coachMarkDismissed: 'trialNetworkViz:coachMarkDismissed',
    taskCompleted: 'trialNetworkViz:taskCompleted',
    nodeClicked: 'trialNetworkViz:nodeClicked',
  },
  welcomeModal: {
    closed: 'welcomeModal:closed',
    opened: 'welcomeModal:opened',
    stepUpdate: 'welcomeModal:stepUpdate',
  },
  certificateDiscovery: {
    started: 'certificateDiscovery:started',
    navigatedToEvidence: 'certificateDiscovery:navigatedToEvidence',
    certificateLinkClicked: 'certificateDiscovery:certificateLinkClicked',
  },
  certificateEnableModal: {
    closed: 'certificateEnableModal:closed',
    feedbackProvided: 'certificateEnableModal:feedbackProvided',
    skipped: 'certificateEnableModal:skipped',
  },
};
